/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { GlobalErrorModalInterface } from '@root/shared/interfaces/global-error-modal.interface';
import { ERROR_MESSAGES } from '@root/shared/components/global-error-modal/global-error-modal.constants';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { ActivatedRoute } from '@angular/router';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';

@Component({
  selector: 'tmo-global-error-modal',
  templateUrl: './global-error-modal.component.html',
  styleUrls: ['../../../../../style-sheets/components/modal.component.scss'],
})
export class GlobalErrorModalComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Display the modal flag
   */
  public displayModal: boolean;
  /**
   * To create the modal name
   */
  public modal: DynamicModal;
  /**
   * Modal data
   */
  // @TODO need to make an interface for this.
  public modalData: boolean;
  /**
   * Flag to control the debug message display
   */
  public isDebugModeOn: boolean;
  /**
   *  Content to be populated in the error modal
   */
  @Input() public errorModalData: GlobalErrorModalInterface;

  /**
   * Event emitter to send an event once CTA in modal is clicked
   * @type {EventEmitter<any>}
   */
  @Output() public navigateToHome: EventEmitter<boolean>;

  constructor(
    public activatedRoute: ActivatedRoute,
    public pdlService: PdlService
  ) {
    super(pdlService, activatedRoute);
    this.navigateToHome = new EventEmitter();
    this.modal = {
      modalName: 'global-error-modal',
    };
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.displayModal = false;
    this.modalData = true;
    // @TODO removed for TestFlight
    // this.isDebugModeOn = this.appConfig.getConfig(GLOBAL_ERROR_MODAL_CONSTANTS.IS_DEBUG_MODE_ON);
    this.isDebugModeOn = false;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  /**
   * Method to close error modal and sliders (retail/care only) when CTA is clicked
   */
  public closeModalAndSliders(): void {
    this.setDisplayModal(false);
    // @TODO Commented out for TestFlight
    // this.navigateToHome.emit(true);
  }

  /**
   * Method to open or close error modal
   */
  public setDisplayModal(displayModal: boolean): void {
    if (ERROR_MESSAGES.hasOwnProperty(this.errorModalData.errors[0].endpoint) && displayModal) {
      this.displayModal = displayModal;
      // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'modalLoad');
      this.errorModalData.errorMessage = this.fetchMessage(this.errorModalData.errors[0].endpoint);
    } else if (!displayModal) {
      this.displayModal = false;
      this.errorModalData.errorMessage = '';
      this.errorModalData.errors = [];
    }
  }

  public fetchMessage(endPoint: string): string {
    let error: string = '';
    if (ERROR_MESSAGES.hasOwnProperty(endPoint)) {
      error = ERROR_MESSAGES[endPoint];
    }
    return error;
  }
}
